/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-boolean-value */
// eslint-disable-next-line react/no-array-index-key
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';

import { Fade } from 'react-awesome-reveal';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  Navigation, Pagination, Scrollbar, A11y, Autoplay,
} from 'swiper/modules';

import 'swiper/swiper-bundle.css';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function Testimonial({ data }) {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="container mx-auto px-6">
        <Fade direction="up" triggerOnce>
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-brand-green-50 text-brand-green-600 text-sm font-semibold tracking-wide uppercase mb-4">
              Testimonials
            </span>
            <h2 className="text-3xl lg:text-5xl text-surface-900 text-center font-extrabold tracking-tight">
              What Our Clients Say
            </h2>
          </div>
        </Fade>

        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
          className="mySwiper"
          loop={true}
          navigation={true}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
        >
          {data.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="glass-card-static mx-2 sm:mx-6 mb-8 mt-4 xl:mx-auto px-8 py-8 max-w-3xl mx-auto">
                <div className="flex items-center mb-6">
                  <img
                    src={item.imageUrl}
                    alt="Testimonial"
                    className="w-16 h-16 rounded-full ring-2 ring-brand-green-200 ring-offset-2 object-cover"
                  />
                  <div className="pl-5">
                    <h3 className="text-surface-900 text-xl font-bold">{item.name}</h3>
                    <p className="text-surface-300 text-sm">{item.company}</p>
                  </div>
                </div>
                <p className="text-surface-300 text-lg leading-relaxed italic pl-2">
                  &ldquo;{item.testimoni}&rdquo;
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
